
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendar",
      function () {
        return require("private-next-pages/calendar.tsx");
      }
    ]);
  